import axios from "axios";

import Config from "../../config";

const getActionCriarChatAndNovaMensagem = data => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/chat/criarChatAndNovaMensagem`,
        data
    });
};

export default getActionCriarChatAndNovaMensagem;
